<template>
  <div class="pn-nav">
    <div class="pn-nav-inner">
      <!-- 类目入口 + 展示分类弹窗（参考 search 项目 NavComponent/CategoryCom/CategoryPopover） -->
      <div class="pn-cate" @mouseenter="cateVisible = true" @mouseleave="cateVisible = false">
        <span class="pn-cate-icon">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none">
            <path d="M1 1h16M1 7h16M1 13h16" stroke="#333" stroke-width="2" stroke-linecap="round"></path>
          </svg>
        </span>
        <div v-if="cateVisible" class="pn-popover">
          <div class="pn-popover-left">
            <ul>
              <li
                v-for="c in cateList"
                :key="c.d_gc_id"
                :class="{ 'pn-active': activeCate && activeCate.d_gc_id === c.d_gc_id }"
                @mouseenter="activeCate = c"
              >
                <div>
                  <a :href="searchUrl(c.d_gc_id)" class="pn-l1-link">{{ c.d_gc_name }}</a>
                </div>
                <div class="pn-second">
                  <span v-for="s in c.cn_classs || []" :key="s.d_gc_id">
                    <a :href="searchUrl(s.d_gc_id)">{{ s.d_gc_name }}</a>
                    <span class="pn-solidus">/</span>
                  </span>
                </div>
                <span class="pn-leftarrow"></span>
              </li>
            </ul>
          </div>
          <div v-show="activeCate" class="pn-popover-right">
            <div class="pn-popover-main">
              <template v-if="hasThirdChild(activeCate)">
                <div
                  v-for="s in activeCate ? activeCate.children || [] : []"
                  :key="s.d_gc_id"
                >
                  <div class="pn-second-title">
                    <a :href="searchUrl(s.d_gc_id)">{{ s.d_gc_name }}</a>
                  </div>
                  <div class="pn-third-list">
                    <a
                      v-for="t in s.children || []"
                      :key="t.d_gc_id"
                      :href="searchUrl(t.d_gc_id)"
                    >
                      {{ t.d_gc_name }}
                    </a>
                  </div>
                </div>
              </template>
              <div class="pn-third-list" v-else>
                <a
                  v-for="s in activeCate ? activeCate.children || [] : []"
                  :key="s.d_gc_id"
                  :href="searchUrl(s.d_gc_id)"
                >
                  {{ s.d_gc_name }}
                </a>
              </div>
              <div
                v-if="activeCate && activeCate.recommend && activeCate.recommend.length"
                class="pn-recommend"
              >
                <div class="pn-recommend-title">新品推荐</div>
                <div class="pn-recommend-list">
                  <div v-for="r in activeCate ? activeCate.recommend : []" :key="r.goods_ids" class="pn-recommend-item">
                    <div class="pn-recommend-tags">
                      <span class="pn-tag-main">{{ r.title_middle_zhu }}</span>
                      <span v-if="r.title_middle_ci" class="pn-tag-sub">{{ r.title_middle_ci }}</span>
                    </div>
                    <div class="pn-recommend-imgs">
                      <a
                        v-if="r.goods_ids_arr[0]"
                        class="pn-img-big"
                        :href="goodsUrl(r.goods_ids.split(',')[0])"
                      >
                        <img :src="r.goods_ids_arr[0].goods_image" :alt="r.goods_ids_arr[0].goods_name" />
                      </a>
                      <div class="pn-img-col">
                        <a
                          v-for="(g, gi) in r.goods_ids_arr.slice(1, 3)"
                          :key="gi"
                          class="pn-img-small"
                          :href="goodsUrl(r.goods_ids.split(',')[gi + 1])"
                        >
                          <img :src="g.goods_image" :alt="g.goods_name" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 导航列表 -->
      <nav class="pn-navlist">
        <a class="pn-nav-link pn-nav-first" :href="CurrentEnvPrefix.main">首页</a>
        <template v-for="n in firstNavList">
          <a
            :key="n.nav_id"
            target="_blank"
            :style="{
              fontSize: n.font_style && n.font_style['font-size'],
              fontWeight: n.font_style && n.font_style['font-weight'],
              color: n.font_style && n.font_style.color,
            }"
            class="pn-nav-link pn-nav-item"
            :href="n.nav_url"
          >
            {{ n.nav_title }}
            <span
              v-if="n.nav_image"
              class="pn-nav-image"
              :style="{ background: 'url(' + n.nav_image + ') no-repeat center', backgroundSize: '100%' }"
            ></span>
          </a>
        </template>
        <div
          v-if="moreNavList.length"
          class="pn-more"
          @mouseenter="showMoreList = true"
          @mouseleave="showMoreList = false"
        >
          更多
          <span class="pn-more-arrow" :class="{ 'pn-more-arrow-open': showMoreList }">▼</span>
          <div v-show="showMoreList" class="pn-more-list">
            <a v-for="n in moreNavList" :key="n.nav_id" :href="n.nav_url" :title="n.nav_title">
              {{ n.nav_title }}
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { CurrentEnvPrefix } from 'config/urlprefix.js';

export default {
  data() {
    return {
      cateVisible: false,
      activeCate: null,
      cateList: [],
      navList: [],
      showMoreList: false,
      // Vue2 模板无法访问 import 变量，挂到 data
      CurrentEnvPrefix,
    };
  },
  computed: {
    firstNavList() {
      return this.navList.filter((n) => !n.is_more);
    },
    moreNavList() {
      return this.navList.filter((n) => n.is_more);
    },
  },
  created() {
    this.queryCategory();
    this.queryNavList();
  },
  methods: {
    // 一级下是否存在三级（无三级时弹层二级按三级样式平铺展示）
    hasThirdChild(list) {
      if (!list || !list.children) return false;
      return list.children.some(function(s) {
        return s.children && s.children.length > 0;
      });
    },
    // 展示分类树（首页/搜索页同源）
    queryCategory() {
      fetch(CurrentEnvPrefix.plapi + '/goods_display_class/get_display_class_nav?SystemName=pc&storeid=1')
        .then((r) => r.json())
        .then((res) => {
          if (Number(res.ResponseStatus) === 0) {
            this.cateList = res.datas || [];
            if (this.cateList.length) {
              this.activeCate = this.cateList[0];
            }
          }
        })
        .catch(() => {});
    },
    // 导航列表（laravel 接口，与 search 项目同源）
    queryNavList() {
      fetch(CurrentEnvPrefix.plapi + '/goods_search/search_nav?SystemName=pc&storeid=1')
        .then((r) => r.json())
        .then((res) => {
          if (Number(res.ResponseStatus) === 0) {
            this.navList = res.datas || [];
          }
        })
        .catch(() => {});
    },
    searchUrl(id) {
      return CurrentEnvPrefix.search + '/?d_gc_id=' + id;
    },
    goodsUrl(goodsId) {
      return CurrentEnvPrefix.productionDetailUrl + '/?goods_id=' + goodsId;
    },
  },
};
</script>

<style scoped>
.pn-nav {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.pn-nav-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1280px;
  margin: 0 auto;
  height: 44px;
}

/* ---- 类目入口 ---- */
.pn-cate {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 4px;
  margin-right: 30px; /* 与导航菜单项间距一致 */
  cursor: pointer;
  flex-shrink: 0;
}

.pn-cate-icon {
  display: flex;
  align-items: center;
}

/* ---- 弹窗（展示分类） ---- */
.pn-popover {
  position: absolute;
  left: 0;
  top: 44px;
  width: 844px;
  display: flex;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16);
  z-index: 9999;
}

.pn-popover-left {
  width: 205px;
  flex-shrink: 0;
  padding: 10px 0;
  border-right: 1px solid #f0f0f0;
}

.pn-popover-left ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pn-popover-left li {
  position: relative;
  padding: 8px 16px;
  cursor: pointer;
}

.pn-popover-left li.pn-active {
  background: #f5f5f5;
}

.pn-l1-link {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

.pn-l1-link:hover {
  color: #ff3838;
}

.pn-second {
  margin-top: 4px;
  height: 18px;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  color: #999;
}

.pn-second a {
  color: #999;
}

.pn-second a:hover {
  color: #ff3838;
}

.pn-solidus {
  padding: 0 5px;
}

.pn-leftarrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
  transform: translateY(-50%) rotate(45deg);
}

.pn-popover-right {
  flex: 1;
  max-height: 545px;
  overflow-y: auto;
  padding: 12px 20px;
}

.pn-second-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  padding: 10px 0 8px;
  border-bottom: 1px dashed #eaeaea;
}

.pn-second-title a {
  color: #333;
}

.pn-second-title a:hover {
  color: #ff3838;
}

.pn-third-list {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 6px;
  padding: 8px 0 14px;
}

.pn-third-list a {
  color: #666;
  font-size: 12px;
}

.pn-third-list a:hover {
  color: #ff3838;
}

.pn-recommend {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 14px;
  margin-top: 8px;
}

.pn-recommend-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  padding-bottom: 10px;
}

.pn-recommend-list {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 20px;
}

.pn-recommend-item {
  width: calc(50% - 10px);
}

.pn-recommend-tags {
  display: flex;
  font-size: 12px;
  color: #fff;
  margin-bottom: 6px;
}

.pn-tag-main {
  background: linear-gradient(90deg, #ff6034, #ff3838);
  padding: 3px 10px;
  border-radius: 4px 0 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60%;
}

.pn-tag-sub {
  background: #eee;
  color: #666;
  padding: 3px 10px;
  border-radius: 0 4px 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pn-recommend-imgs {
  display: flex;
}

.pn-img-big {
  display: block;
  width: 176px;
  height: 176px;
  overflow: hidden;
  border-radius: 6px;
  margin-right: 6px;
  flex-shrink: 0;
}

.pn-img-big img {
  width: 176px;
  height: 176px;
  object-fit: cover;
}

.pn-img-col {
  display: flex;
  flex-direction: column;
}

.pn-img-small {
  display: block;
  width: 85px;
  height: 85px;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 6px;
}

.pn-img-small img {
  width: 85px;
  height: 85px;
  object-fit: cover;
}

/* ---- 导航列表 ---- */
.pn-navlist {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.pn-nav-link {
  position: relative;
  margin-right: 30px;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.pn-nav-link::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -4px;
  width: 30px;
  height: 2px;
  background-color: #ff3838;
  transform: translateX(-50%) scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.pn-nav-link:hover {
  color: #ff3838 !important;
}

.pn-nav-link:hover::after {
  transform: translateX(-50%) scaleX(1);
}

.pn-nav-first {
  font-weight: bold;
  color: #333;
}

.pn-nav-image {
  position: absolute;
  width: 26px;
  height: 20px;
  top: -10px;
  right: -30px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.pn-more {
  position: relative;
  font-weight: bold;
  cursor: pointer;
  color: #333;
  white-space: nowrap;
}

.pn-more-arrow {
  font-size: 12px;
  position: relative;
  top: -3px;
  display: inline-block;
  transition: transform 0.3s ease;
}

.pn-more-arrow-open {
  transform: rotate(180deg);
}

.pn-more-list {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 60px;
  background: #fff;
  border-radius: 8px;
  z-index: 9999;
  padding: 8px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  max-height: 200px;
  overflow-y: auto;
}

.pn-more-list a {
  display: block;
  padding: 8px 4px;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
}

.pn-more-list a:hover {
  background: #f5f5f5;
  color: #ff3838;
}
</style>



// WEBPACK FOOTER //
// src/components/public/publicnav.vue